import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { MentionsInput, Mention } from 'react-mentions'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import './emoji-mart.css'
import './dart_internal.css'
import { setIsDoingACommentWithFile, unsetIsDoingACommentWithFile } from "../../actions/CommentAction"
import MainAudioRecorder from "./MainAudioRecorder"


class MainMentionInput2 extends Component {

    constructor(props) {
        super(props)
        this.state = {
            attachedFile: null,
            isUploadingFile: false,
            showEmojiPicker: false,
            drop: true
        }

        this.ref = React.createRef()
    }

    componentDidMount() {
        const inputDartMain = ReactDOM.findDOMNode(
            this.refs.commentRefAnswer
        ).getElementsByClassName('dart-input-text__input')
        if (inputDartMain.length > 0) inputDartMain[0].removeAttribute('style')
        const highlighterDartMain = ReactDOM.findDOMNode(this.refs.commentRefAnswer).getElementsByClassName('dart-input-text__highlighter')
        if (highlighterDartMain.length > 0) highlighterDartMain[0].removeAttribute('style')
    }

    render() {
        const {
            comment,
            usersMentions,
        } = this.props
        const {
            handleOnChangeInput,
            inputValue,
            handleKeyDown,
            placeholderValue,
            onAddHandler,
            showAudioRecorder
        } = this.props

        return (
            <div className="main-button-input">


                <MentionsInput
                    // style={{ width: '30vw' }}
                    className={`dart-input-text mentionInput-${comment._id}`}
                    type="textarea"
                    onKeyDown={handleKeyDown}
                    placeholder={placeholderValue}
                    value={inputValue}
                    onChange={handleOnChangeInput}
                    singleLine={false}
                    ref={'commentRefAnswer'}
                    allowSuggestionsAboveCursor={true}
                    id={`mentionInput-${comment._id}`}
                >
                    <Mention
                        trigger="@"
                        data={usersMentions}
                        displayTransform={(id, display) => {
                            return display
                        }}
                        appendSpaceOnAdd={true}
                        onAdd={onAddHandler}
                    />
                </MentionsInput>
                {
                    showAudioRecorder &&
                    <MainAudioRecorder
                        sendAudioMessage={this.props.sendAudioMessagehandler}
                        showAudioRecorder={this.props.showAudioRecorder}
                    />
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.authUser.user,
        clientId: state.client.data ? state.client.data._id : null,
        clientName: state.client.data ? state.client.data.name : "",
    }
}

const mapDispatchToProps = {
    setIsDoingACommentWithFile,
    unsetIsDoingACommentWithFile
}

export default injectIntl(
    withRouter(connect(mapStateToProps, mapDispatchToProps)(MainMentionInput2))
)
